import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardBody } from '../components/CardBody/CardBody';
import { Input } from '../components/Input/Input';
import { Select } from '../components/Select/Select';
import {Col, Row, Spinner, Button, Container, Alert} from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { api } from '../services/Api';
import { useAlert } from '../contexts/AlertContext';
import {cvvCardMask, numberCreditCardMask, validateCardMask} from '../Utils/Mask';
import { getCurrentMonthAndYear } from '../Utils/currentDate';
import Navbar from "react-bootstrap/Navbar";
import logoImg from "../assets/netcomet.png";

interface Client {
	documento: string;
	nome: string;
}

export function RegisterCard() {

	const url = window.location.href.split('listar_informacoes/');
	const token = url[1];

	const { handleSetAlert } = useAlert();

	const [numberCardSelected, setNumberCardSelected] = useState<string>('');
	const [nameCardSelected, setNameCardSelected] = useState<string>('');
	const [flagCardSelected, setFlagCardSelected] = useState<string>('');
	const [validateCardSelected, setValidateCardSelected] = useState<string>('');
	const [cvvCardSelected, setCvvCardSelected] = useState<string>('');
	const [message, setMessage] = useState<string>('');
	const [varianteMessage, setVarianteMessage] = useState<string>('');
	const [client, setClient] = useState<Client | null>(null);
	const [loadingInformation, setLoadingInformation] = useState<boolean>(true);

	useEffect(() => {

		const headers = {
			'Content-Type': 'application/json',
		};

		api.get('v1/contratos-servicos/link-cadastrar-cartao/'+token, { headers })
			.then((response) => {
				setClient(response.data.cliente)
				setLoadingInformation(false);
			})
			.catch(() => {
				setMessage('Este link não está disponível. Para mais informações entre em contato com a nossa central de atendimento no telefone '+process.env.REACT_APP_SUPERGER_TELEFONE);
				setLoadingInformation(false);
				setVarianteMessage('danger')
			});

	}, [token]);


	function handleRegisterCard(){
		let dateCard = [];
		let dateCardConcat = '';
		if (validateCardSelected) {
			dateCard = validateCardSelected.split('/');
			if (!dateCard[1]) {
				dateCardConcat = dateCard[0];
			} else {
				dateCardConcat = dateCard[1]+dateCard[0];
			}
		}


		if (!numberCardSelected) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: "Digite o número do cartão",
				timeout: 5000
			});
			return false;
		} else if (!nameCardSelected) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: "Digite o nome inserido no cartão",
				timeout: 5000
			});
			return false;
		} else if (!flagCardSelected) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: "Insira a bandeira do cartão",
				timeout: 5000
			});
			return false;
		} else if (!validateCardSelected) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: "Insira a validade do cartão",
				timeout: 5000
			});
			return false;
		} else if (validateCardSelected.length < 7) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: "Validade do cartão inválida, informe a data com o ano completo",
				timeout: 5000
			});
			return false;
		} else if (parseInt(dateCardConcat) < parseInt(getCurrentMonthAndYear())) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: "Validade do cartão inválida",
				timeout: 5000
			});
			return false;
		} else if (!cvvCardSelected) {
			handleSetAlert({
				visible: true,
				variant: 'warning',
				message: "Insira o código de segurança do cartão",
				timeout: 5000
			});
			return false;
		}

		setLoadingInformation(true);

		api.get('https://api.ipify.org?format=json')
			.then((responseJson) => {

				let validateCard = validateCardSelected.trim().split('/');

				let data = {
					token_link: token,
					numero: numberCardSelected.trim().replace('-', ''),
					nome: nameCardSelected,
					bandeira: flagCardSelected,
					cvv: cvvCardSelected,
					mes: validateCard[0],
					ano: validateCard[1],
					ip: responseJson.data.ip,
					navegador: navigator.userAgent
				}

				const headers = {
					'Content-Type': 'application/json',
				};

				api.post('v1/contratos-servicos/link-cadastrar-cartao', data, { headers })
					.then((response) => {
						setMessage(response.data.message);
						setVarianteMessage('success');
						setLoadingInformation(false);
					}).catch((erro) => {
						setMessage(erro.response.data.message);
						setVarianteMessage('danger');
						setLoadingInformation(false);
					});
			}).catch((erro) => {
				setMessage(erro.response.data.message);
				setVarianteMessage('danger');
				setLoadingInformation(false);
			});
	}

	return(
		<>
			<Navbar collapseOnSelect style={{height: 80}} className="header p1" expand="lg">
				<Container>
					<Navbar.Brand>
						<img src={logoImg} alt="Logo Netcomet"/>
					</Navbar.Brand>
					<a href="https://cliente.netcomet.com.br/login" rel="noreferrer" target="_blank">
						<Navbar.Brand className="d-flex align-items-center color-dark-gray">
							<span className="material-icons title-icon">face</span>
							<p className="m-0">Portal do Cliente</p>
						</Navbar.Brand>
					</a>
				</Container>
			</Navbar>
			<Container className="container-login p-3">
				{(loadingInformation || (!loadingInformation && message)) && <Row className="h-100">
					<Col md={12} className="align-self-center">
						{loadingInformation && <div className="vh-100 justify-content-center align-items-center d-flex">
							<Spinner animation="border" role="status"/>
						</div>
						}
						{!loadingInformation && message && <div className="vh-100 justify-content-center align-items-center d-flex">
							<Alert className="alert-component text-center" variant={varianteMessage}>{message}</Alert>
						</div>}
					</Col>
				</Row>}
				{!loadingInformation && !message && <>
					<Row>
						<Col md={12}>
							<Row className="m-card justify-content-center">
								<Col md={12} className="d-flex justify-content-center">
									<CardInfo variant="w-100">
										<CardBody className="m-4">
											<Row>
												<Col md={6} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<p><strong>Nome: </strong>{client?.nome}</p>
													</div>
												</Col>
												<Col md={6} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<p><strong>CPF/CNPJ: </strong>{client?.documento}</p>
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={12} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<Input
															icon="payment"
															type="text"
															placeholder="Número do Cartão"
															onChange={(value) => {setNumberCardSelected(numberCreditCardMask(value.target.value))}}
															value={numberCardSelected}
														/>
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={6} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<Input
															icon="face"
															type="text"
															placeholder="Nome no Cartão"
															onChange={(value) => {setNameCardSelected(value.target.value.toUpperCase())}}
															value={nameCardSelected}
														/>
													</div>
												</Col>
												<Col md={6} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<Input
															icon="calendar_today"
															type="text"
															placeholder="Validade do Cartão"
															onChange={(value) => {setValidateCardSelected(validateCardMask(value.target.value))}}
															value={validateCardSelected}
														/>
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={6} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<Select
															icon="flag"
															onChange={(value) => {setFlagCardSelected(value.target.value)}}
														>
															<option value="">Selecione a Bandeira</option>
															<option value="Visa">Visa</option>
															<option value="Master">Master</option>
															<option value="Elo">Elo</option>
														</Select>
													</div>
												</Col>
												<Col md={6} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<Input
															icon="lock"
															type="text"
															placeholder="Código do Cartão (CVV)"
															onChange={(value) => {setCvvCardSelected(cvvCardMask(value.target.value))}}
															value={cvvCardSelected}
														/>
													</div>
												</Col>
											</Row>
											<Row>
												<Col md={12} sm={12} xs={12}>
													<div className="mb-4 w-100">
														<Button variant="success d-flex justify-content-center" onClick={() => {handleRegisterCard();}} className="w-100">
															Cadastrar Cartão
														</Button>
													</div>
												</Col>
											</Row>
										</CardBody>
									</CardInfo>
								</Col>
							</Row>
						</Col>
					</Row>
				</>}
			</Container>
		</>
	);
}
